import SectionHeading from '../common/SectionHeading';
import { contact, recruitCards } from '../../data/siteContent';

function RecruitSection() {
  return (
    <section className="block recruit-section" id="recruit">
      <div className="wrap">
        <SectionHeading eyebrow="RECRUIT" title="함께 성장할 동료를 찾습니다">혼자 가면 빨리 가지만, 함께 가면 멀리 갑니다. 보험이라는 일을 제대로 배우고 정직하게 오래 하고 싶은 분이라면, 이동은과 함께 시작해 보세요.</SectionHeading>
        <div className="cards">
          {recruitCards.map(([title, body]) => (
            <article className="card reveal" key={title}><h3>{title}</h3><p>{body}</p></article>
          ))}
        </div>
        <div className="recruit-cta reveal">
          <div className="recruit-copy">
            <b>이런 분과 함께하고 싶습니다</b>
            <ul><li>사람을 진심으로 대하는 분</li><li>배우려는 태도가 있는 분</li><li>시간을 주도적으로 쓰며 제대로 성장하고 싶은 분</li></ul>
          </div>
          <div className="recruit-buttons">
            <a className="button button-call" href={`tel:${contact.phone}`}>전화 문의</a>
            <a className="button button-kakao" href={contact.kakao} target="_blank" rel="noreferrer">카톡 문의</a>
            <a className="button button-insta" href={contact.instagram} target="_blank" rel="noreferrer">인스타 DM</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RecruitSection;
